export const alertFetchErrorMessage = (message = null) => {
    alert(message ? message : "Un problème est survenu, veuillez réessayer");
}